import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const adminRoutes  = import(/* webpackChunkName:"admin" */  "./routes/admin");
const publicRoutes = import(/* webpackChunkName:"public" */ "./routes/public");
const webRoutes    = import(/* webpackChunkName:"web" */    "./routes/web");

export default async function(area) {
  let routes;

  if (area === "admin") routes = await adminRoutes;
  else if (area === "web") routes = await webRoutes;
  else routes = await publicRoutes;

  return new VueRouter({
    mode: "history",
    routes: routes.default,
  });
}



// WEBPACK FOOTER //
// ./src/router/router.js